import { BrandCategoryBreakPoints } from "@/constants/BreakPoints";
import { useClient } from "@/hooks/useClient";
import Link from "next/link";

import { useRouter } from "next/router";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// import Link from "next/link"

const TopDealsSwiper = ({ data = [] }) => {
  const { locale } = useRouter();
  const { isClient } = useClient();
  return isClient && data?.length ? (
    <Swiper
      loop
      key={locale}
      dir={locale === "en" ? "ltr" : "rtl"}
      modules={[Autoplay]}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      spaceBetween={15}
      breakpoints={BrandCategoryBreakPoints}
      className="flex gap-4 col-span-full"
    >
      {isClient && data?.map((item, idx) => {
        return (
          <SwiperSlide
            // className="py-1"
            className={`border px-2 py-1 cursor-pointer line-clamp-1 text-xs text-[#6A6262] sm:text-base text-center`}
            key={item?.url_key+'_'+idx}
          >
            <Link href={`/${item?.url_key}`}>{item?.name}</Link>
          </SwiperSlide>
        );
      })}
    </Swiper>
  ) : null;
};

export default TopDealsSwiper;
